import { AllergenType } from "../types";
import { DishTypeCategory, MealListSortDirectionEnum, MealListSortTypeEnum } from "../types/mainTypes";

// Values that are the same in every environment and every build. Packages import them directly; the
// app's Config re-uses them, so there is one definition. Everything that depends on the environment
// goes through the config port instead (see terminalConfig.ts).

export const DEFAULT_LOCALE = "cs-CZ";
export const LOCALE_STORAGE_KEY = "locale";
export const DEFAULT_NAMESPACE = "translation";

export const CATEGORY_ORDER = {
	[DishTypeCategory.MEAL]: 0,
	[DishTypeCategory.SOUP]: 1,
	[DishTypeCategory.SNACK]: 2,
};

export const MEAL_LIST_ORDER = {
	categoryOrder: CATEGORY_ORDER,
	dishTypeOrder: MealListSortTypeEnum.NAME, // PRICE | NAME
	dishTypeOrderDirection: MealListSortDirectionEnum.ASCENDING, // ASC | DESC
};

export const HIGHLIGHTED_ALLERGENS = [AllergenType.Milk, AllergenType.Gluten, AllergenType.Eggs];

export const FILTER_MIXPANEL_TRACKING_DEBOUNCE = 5000;
